import React, { useMemo } from 'react';
import LeadershipChrome from '@/components/LeadershipChrome';
import { RECEPTION_MENU } from '@/config/navigationMenus';
import { useAuth } from '@/contexts/AuthContext';
import { useTenant } from '@/contexts/TenantContext';
import { LEADERSHIP_CONTENT } from '@/config/leadershipLayout';

/**
 * Reception / nursing shell — same IITH campus chrome as FIC (top nav),
 * not the old left sidebar. Clinic /admin keeps its own sidebar layout.
 */
export default function ReceptionLayout({ children, pageTitle, pageSubtitle, rightActions }) {
  const { user } = useAuth();
  const { tenant } = useTenant();
  const showManagement =
    tenant?.capabilities?.reception_can_view_management === true ||
    ['management', 'admin', 'fic'].includes((user?.role || '').toLowerCase());

  const menuItems = useMemo(() => {
    const items = [...RECEPTION_MENU];
    if (showManagement) {
      items.push({ to: '/management', label: 'Management', testid: 'rx-nav-management' });
    }
    return items;
  }, [showManagement]);

  const role = (user?.clinic_role || user?.role || 'reception').replace(/_/g, ' ');

  return (
    <LeadershipChrome
      homeHref="/reception/home"
      roleLabel={role}
      menuItems={menuItems}
    >
      <div className={LEADERSHIP_CONTENT} data-testid="reception-layout">
        {(pageTitle || rightActions) ? (
          <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
            <div className="min-w-0">
              {pageTitle ? (
                <h1 className="text-2xl font-semibold text-[#071B34] font-heading truncate">
                  {pageTitle}
                </h1>
              ) : null}
              {pageSubtitle ? (
                <p className="text-sm text-[#5A6B7C] mt-1">{pageSubtitle}</p>
              ) : null}
            </div>
            {rightActions ? <div className="flex items-center gap-2 flex-shrink-0">{rightActions}</div> : null}
          </div>
        ) : null}
        {children}
      </div>
    </LeadershipChrome>
  );
}
